import type { JSX } from "preact";

type IconProps = JSX.SVGAttributes<SVGSVGElement>;

export function IcoChevronUp({ class: className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
      {...props}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m4.5 15.75 7.5-7.5 7.5 7.5"
      />
    </svg>
  );
}
